package or.garden.manager.domain.request

import kotlinx.serialization.Serializable

@Serializable
data class CreateSeedRequest(
    val name: String,
    val latinName: String? = null,
    val hybrid: Boolean? = false,
    val photo: String? = null,
    // new fields to match server
    val type: String? = null,
    val harvestTime: Int? = null,
    val seedlingDate: String? = null,
    val backPhoto: String? = null
)
